module.exports = __webpack_public_path__ + "assets/img/202112-1W.d65b660c.png";